import { FieldsType } from "./types";

type FieldsConstProps = {
  title: string;
  customId: string;
  editPermissions: string;
  wrapperTitle: string;
  infoMessage?: string;
  customApproveTitle?: string;
  searchPlaceholder?: string;
  buttonText?: string;
  /** Default true: invalid inputs block submit. False: the format is only suggested
   * (no blocking, a broken pattern shows a warning badge instead of an error). */
  blockSubmitOnInvalidInputs?: boolean;
};

export const FIELDS_PROPS: { [key in FieldsType]: FieldsConstProps } = {
  feed: {
    title: "Sources",
    customId: "uploadFeedButton",
    editPermissions: "site:basic_config:update",
    wrapperTitle: "Data sources",
    customApproveTitle: "Save settings",
    searchPlaceholder: "https://example.com/feed.csv",
  },
  field: {
    title: "Fields",
    customId: "customFieldsButton",
    editPermissions: "site:advanced_config:update",
    wrapperTitle: "Site Custom Fields",
    infoMessage:
      "Products will update to the new schema after the feed (re)-import",
  },
  query: {
    title: "Query-to-URL Mapping",
    customId: "queryMappingButton",
    editPermissions: "campaign:basic_config:update",
    wrapperTitle: "Query-to-URL Mapping",
    searchPlaceholder: "Query or URL",
    blockSubmitOnInvalidInputs: false,
  },
  boosting: {
    title: "Boosting",
    customId: "boostingButton",
    editPermissions: "campaign:basic_config:update",
    wrapperTitle: "Boosting",
    searchPlaceholder: "Column",
  },
  preferredValues: {
    title: "Preferred values",
    customId: "preferredValuesButton",
    editPermissions: "campaign:basic_config:update",
    wrapperTitle: "Preferred values",
    searchPlaceholder: "Value",
    buttonText: "Add value",
  },
  linkedBoosting: {
    title: "Linked Boosting Campaigns",
    customId: "linkedBoostingButton",
    editPermissions: "campaign:basic_config:update",
    wrapperTitle: "Linked Boosting Campaigns",
    searchPlaceholder: "Name",
    buttonText: "Add campaign",
  },
};
